import React from 'react';
import data from '../../data/main-page/demos';
function Demos() {
  return (
    <section className="tc-demos">
      <div className="container">
        <div className="top-info mb-60 wow fadeInUp slow" data-wow-delay="0.2s">
          <div className="row justify-content-between">
            <div className="col-lg-5">
              <h3 className="fsz-45 fw-600">
                What we <br /> offer
              </h3>
            </div>
            <div className="col-lg-5">
              <div className="text fsz-16 color-666 text-lg-end mt-4 mt-lg-0">
                Authorized Distributor of Delby — Offering a premium collection of <br /> 
                high-quality PVC, WPC, and designer wallpapers.
              </div>
            </div>
          </div>
        </div>
        <div className="cards">
          <div className="row">
            {data.map((item, i) => (
              <div key={i} className="col-lg-4">
                <a
                  href={item.link}
                  className="demo-card wow fadeInUp slow"
                  data-wow-delay={item.delay}
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="img">
                    <img src={item.img} alt="" className="img-cover" loading="lazy" decoding="async" />
                  </div>
                  <div className="info">
                    <h6 className="fsz-16 fw-bold"> {item.title} </h6>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="marq-content">
        <div className="marq-slider">
          <div className="swiper-wrapper">
            <div className="swiper-slide">
              <a href="#0"> Authorized Delby Distributor </a>
            </div>
            <div className="swiper-slide">
              <a href="#0"> Premium PVC Panels </a>
            </div>
            <div className="swiper-slide">
              <a href="#0"> Luxury WPC Louvers </a>
            </div>
            <div className="swiper-slide">
              <a href="#0"> Designer Wallpapers </a>
            </div>
            <div className="swiper-slide">
              <a href="#0"> Charcoal Wall Panels </a>
            </div>
            <div className="swiper-slide">
              <a href="#0"> Modern Interior Solutions </a>
            </div>
            <div className="swiper-slide">
              <a href="#0"> Durable & Stylish Decor </a>
            </div>
            <div className="swiper-slide">
              <a href="#0"> High-Quality Wall Cladding </a>
            </div>
            <div className="swiper-slide">
              <a href="#0"> Elegant Interior Finishes </a>
            </div>
            <div className="swiper-slide">
              <a href="#0"> Trusted Delby Partner </a>
            </div>
            <div className="swiper-slide">
              <a href="#0"> Premium PVC Panels </a>
            </div>
            <div className="swiper-slide">
              <a href="#0"> Luxury WPC Louvers </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Demos;
